import { Component, computed, effect, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { CartService } from '../../../services/cart.service';

@Component({
  selector: 'app-site-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './site-header.component.html',
  styleUrl: './site-header.component.scss'
})
export class SiteHeaderComponent {
  protected readonly cart = inject(CartService);
  protected readonly auth = inject(AuthService);

  readonly user = this.auth.currentUser;

  readonly userInitials = computed(() => {
    const name = this.user()?.name ?? '';
    return name
      .split(' ')
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase() ?? '')
      .join('');
  });

  readonly userFirstName = computed(() => {
    const name = this.user()?.name?.trim();
    return name ? name.split(/\s+/)[0] : '';
  });

  readonly cartCount = computed(() => this.cart.itemCount());

  readonly cartAriaLabel = computed(() => {
    const n = this.cartCount();
    if (n === 0) return 'Carrito vacío';
    if (n === 1) return 'Carrito, 1 artículo';
    return `Carrito, ${n} artículos`;
  });

  readonly cartBadgeLabel = computed(() => {
    const n = this.cartCount();
    return n > 99 ? '99+' : String(n);
  });

  readonly cartBadgePulse = signal(false);

  private cartCountPrev = 0;
  private cartCountInitialized = false;

  menuOpen = false;

  constructor() {
    effect(() => {
      const count = this.cartCount();
      if (this.cartCountInitialized && count > this.cartCountPrev) {
        this.cartBadgePulse.set(true);
        window.setTimeout(() => this.cartBadgePulse.set(false), 500);
      }
      this.cartCountInitialized = true;
      this.cartCountPrev = count;
    });
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  noopClick(event: Event): void {
    event.preventDefault();
  }

  logout(event: Event): void {
    event.preventDefault();
    this.auth.logout();
    this.closeMenu();
  }
}
